var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialistCertificate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0a60 60 0 11-48.46 95.378l24.23-17.69A30 30 0 1060 30V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.204 15.873a.626.626 0 00-.124.379v36.007c0 .518.587.818 1.007.515l13.55-9.778.193.134.17.332.082-.158 13.764 9.509a.635.635 0 00.996-.523V16.22a.636.636 0 00-.056-.263C53.8 23.243 47.556 28.859 40 28.859c-7.585 0-13.848-5.66-14.797-12.986z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.999,
    cy: 13.333,
    r: 13.333
  })));
}
export default SvgSpecialistCertificate;